import PropTypes from 'prop-types';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import UILink from 'UIComponents/link/UILink';
import UIResultsMessage from 'UIComponents/results/UIResultsMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const portalId = PortalIdParser.get();
function ToolAccessGuardRequestPending(props) {
  const {
    approver
  } = props.toolAccess.request;
  return /*#__PURE__*/_jsxs(UIResultsMessage, {
    "data-test-id": "tool-access-guard-request-pending",
    illustration: "successful-send",
    title: /*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "toolAccess.requestPending"
      })
    }),
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "toolAccess.requestPendingTextA",
        options: Object.assign({}, approver)
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "toolAccess.requestPendingTextB"
      })
    }), /*#__PURE__*/_jsx(UILink, {
      href: `/home?portalId=${portalId}`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "toolAccess.goToHome"
      })
    })]
  });
}
ToolAccessGuardRequestPending.propTypes = {
  toolAccess: PropTypes.object
};
export default ToolAccessGuardRequestPending;